module.exports = __webpack_public_path__ + "static/media/uwu.7c7de895.gif";